/**
 * Pending "retry pending" caregiver notices for SMS health-check no-reply retries.
 * Documents are inserted when a timeout completes and a retry is scheduled; the
 * check-sms-call-timeouts cron drains the queue so sends survive cron timing skew.
 */
export interface HcRetryPendingCaregiverNotificationQueueDoc {
  _id?: string;
  /** Unique per outbound SMS attempt — `${historyId}:${activeCallId}` (one caregiver ping per timed-out active call) */
  dedupeKey: string;
  historyId: string;
  csId: string;
  flowId: string;
  /**
   * Schedule slot spacing from flow — fallback only if `nextRetryAt` is unavailable when the queue drains.
   * Display minutes should come from `HcHistory.nextRetryAt` vs now.
   */
  windowMinutes: number;
  createdAt: Date;
}
